import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider, Route } from 'react-router5';
import * as Actions from '../common/services/actions';
import configureStore from '../common/services/store';
import router from '../common/routes/router';
import SearchResults from '../listings/search/SearchResults';
import SearchInput from '../listings/search/SearchInput';
import SearchTabs from '../listings/search/SearchTabs';

let store;

function SearchApp(memberGroups, isAuth) {
	return (
		<Provider store={store}>
			<RouterProvider router={router}>
				<SearchResults memberGroups={memberGroups} isAuth={isAuth} store={store} />
			</RouterProvider>
		</Provider>
	);
}

function SearchInputApp() {
	return (
		<Provider store={store}>
			<SearchInput />
		</Provider>
	);
}

function SearchTabsApp() {
	return (
		<Provider store={store}>
			<SearchTabs />
		</Provider>
	);
}
export function renderSearch(id, mg, auth) {
	if (!store) {
		store = configureStore(router);
	}
	//decode the string to get the groups
	var groups = atob(mg) != null ? atob(mg) : 'Public';
	store.dispatch(Actions.initialiseSettings('search', groups, auth));
	store.dispatch(Actions.loadSynonyms());
	router.start(() => {
		ReactDOM.render(<SearchApp memberGroups={groups} isAuthenitcated={auth} />, document.getElementById(id));
	});
}

export function renderSearchInput(id) {
	if (!store) {
		store = configureStore(router);
	}
	store.dispatch(Actions.initialiseSettings('search'));
	router.start(() => {
		ReactDOM.render(<SearchInputApp />, document.getElementById(id));
	});
}

export function renderSearchTabs(id) {
	if (!store) {
		store = configureStore(router);
	}
	store.dispatch(Actions.initialiseSettings('search'));
	router.start(() => {
		ReactDOM.render(<SearchTabsApp />, document.getElementById(id));
	});
}
